// Seletor de forma de pagamento (lista compacta + selo "Recomendado") na etapa "Confirmar" da página pública — LIBERADO PARA TODAS as empresas.
//
// Mesmo padrão de config/predictedEndFlags.ts: a decisão usa o id da empresa CARREGADA na página (resposta de /public/:slug) — nunca o usuário
// logado nem parâmetros da URL. Sem empresa identificada = visual original. Os meios exibidos vêm SEMPRE das configurações de cada empresa
// (mp_pix_enabled / mp_card_enabled / mp_cash_enabled): este flag só escolhe o visual, não copia dados de nenhuma empresa.
// companyIds: lista de empresas liberadas; null = todas. enabled:false desliga tudo (volta ao visual anterior em todas).

export interface PaymentSelectorFlag {
  enabled: boolean;
  companyIds: number[] | null;
}

export const PAYMENT_SELECTOR_B_FLAG: PaymentSelectorFlag = { enabled: true, companyIds: null };

export function isPaymentSelectorBOn(companyId: unknown, flag: PaymentSelectorFlag = PAYMENT_SELECTOR_B_FLAG): boolean {
  if (!flag.enabled) return false;
  if (typeof companyId !== 'number' && typeof companyId !== 'string') return false;
  if (typeof companyId === 'string' && !/^\d+$/.test(companyId.trim())) return false;
  const id = Number(companyId);
  if (!Number.isInteger(id) || id <= 0) return false; // empresa não identificada: visual original
  return flag.companyIds === null ? true : flag.companyIds.includes(id);
}
